import { flowRight as compose } from "lodash";
import { reachLinkModule } from "@xingternal/crate-communication-reach-link-module";
import { scrollMemoModule } from "@xingternal/crate-layout-scroll-memo-module";
import { frameConfigModule } from "@xingternal/frame-config-module";
import { initialDataModule } from "@xingternal/initial-data-module";
import { splitkitHubModule } from "@xingternal/splitkit";
import { themingModule } from "@xingternal/theming-module";
import { XingFrameProvider } from "@xingternal/xing-frame-provider";
import {
  withApolloClient,
  withHub,
  withStaticDataOnly
} from "@xingternal/xing-frame-provider";
import navigationData from "@xingternal/xing-frame-provider/data/navigation";
import { withHubData } from "@xingternal/xing-frame-provider/lib/withHubData";
const withLoggedInContexts = compose(withStaticDataOnly({ navigationData }), withApolloClient, withHub([
  initialDataModule,
  themingModule,
  reachLinkModule,
  splitkitHubModule,
  scrollMemoModule,
  frameConfigModule
]), withHubData);
const LoggedInFrameProvider = withLoggedInContexts(XingFrameProvider);
const withLoggedOutContexts = compose(withStaticDataOnly({ navigationData }), withApolloClient, withHub([
  themingModule,
  reachLinkModule,
  splitkitHubModule,
  scrollMemoModule,
  frameConfigModule
]), withHubData);
const LoggedOutFrameProvider = withLoggedOutContexts(XingFrameProvider);
export {
  LoggedInFrameProvider,
  LoggedOutFrameProvider
};
